import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import { IModalState } from './modal-types.store';
import { ModalState } from './modal-state.store';
import { mutations } from './modal-mutations.store';
import { actions } from './modal-actions.store';
import { getters } from './modal-getters.store';

export class ModalModule<RootState> implements Module<IModalState, RootState>{
  namespaced: boolean;
  state: IModalState;
  getters: GetterTree<IModalState, RootState>;
  actions: ActionTree<IModalState, RootState>;
  mutations: MutationTree<IModalState>;

  constructor() {
    this.namespaced = true;
    this.state = new ModalState();
    this.mutations = mutations;
    this.actions = actions;
    this.getters = getters;
  }
}